module.exports = __webpack_public_path__ + "media/images/ui-glass-57c37f49.jpg";